export default __webpack_public_path__ + "static/media/slider8.0e20a50a.jpeg";